<template>
  <div class="addShop">
    <a-form
      layout="horizontal"
      :ref="torefs"
      :model="submitForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <df-titleline :title="'基本信息'"></df-titleline>

      <a-form-item label="商户名称" name="companyName">
        <a-input
          v-model:value="submitForm.companyName"
          placeholder="商户名称"
          style="width: 382px"
          :disabled="look"
        />
      </a-form-item>

      <!-- <a-form-item label="商户类型">
                 <a-radio-group default-value="b" button-style="solid" :disabled="look">
                    <a-radio-button value="b">
                        供应
                    </a-radio-button>
                </a-radio-group>
            </a-form-item> -->

      <df-titleline :title="'附加信息'"></df-titleline>

      <a-form-item label="业务类型" name="business">
        <a-checkbox-group
          style="margin-left: 10px"
          v-model:value="submitForm.business"
          :disabled="look"
        >
          <a-checkbox
            v-for="(value, key) in staticof.business"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>

      <a-form-item
        :wrapper-col="{ span: 14, offset: 2 }"
        v-for="(value, key) in settlements"
        :key="key"
      >
        <div class="bussiness_title">{{ settlementsValue[key] }}：</div>

        <a-table
          :columns="columns"
          bordered
          :data-source="value"
          :pagination="false"
          :row-key="(r) => r.lid"
        >
          <template v-slot:number="{ text, record }">
            <span>
              <a-input
                v-model:value="record.beginRange"
                style="width: 45%"
                type="number"
                :disabled="look"
              />
              -
              <a-input
                v-model:value="record.endRange"
                style="width: 45%"
                type="number"
                :disabled="look"
              />
            </span>
          </template>
          <template v-slot:premium="{ text, record }">
            <a-input
              v-model:value="record.priceIncrease"
              :disabled="record.rateInfo ? true : false || look"
              style="width: 90%"
              type="number"
            />
          </template>

          <template v-slot:rate="{ text, record }">
            <a-input
              v-model:value="record.rateInfo"
              :disabled="record.priceIncrease ? true : false || look"
              style="width: 90%"
              type="number"
              suffix="%"
            />
          </template>

          <template
            v-slot:operation="{ text, record, index }"
            class="table-operation"
            v-if="!look"
          >
            <a-button
              type="danger"
              @click="delList(key, index, record)"
              v-if="value.length > 1"
            >
              删除
            </a-button>
            <a-button
              type="primary"
              @click="addList(key, record)"
              style="margin-left: 10px"
              v-if="index == value.length - 1"
            >
              添加
            </a-button>
          </template>
        </a-table>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 14, offset: 2 }" v-if="!look">
        <a-button
          type="primary"
          size="large"
          @click="submitFormAction('submitForm')"
          :loading="loading"
          style="margin-top: 20px"
        >
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import shopApi from "@axios/shop";
import staticof from "@assets/static";
import { reactive, ref, nextTick, refs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";

let VUE_APP_URL = process.env.VUE_APP_URL;

export default {
  name: "addShop",
  components: {},
  setup() {
    const route = useRoute();
    const router = useRouter();
    let itemrefs = [];
    const torefs = (el) => {
      itemrefs.push(el);
    };

    let settlements = ref({
      // train : [{
      //     businessModules : '10',
      //     beginRange : '',
      //     endRange : '',
      //     rateIncrease : '',
      //     priceIncrease : ''
      // }],
    });
    const settlementsKeys = {
      10: "train",
      20: "hotel",
      30: "domesticTicket",
      40: "internationalTicket",
      50: "taxi",
    };

    const settlementsValue = {
      train: "火车票",
      hotel: "酒店",
      domesticTicket: "国内机票",
      internationalTicket: "国际机票",
      taxi: "打车",
    };

    const columns = [
      {
        title: "数量",
        dataIndex: "number",
        width: 350,
        align: "center",
        slots: { customRender: "number" },
      },
      {
        title: "加价费/张/元",
        dataIndex: "premium",
        width: 200,
        align: "center",
        slots: { customRender: "premium" },
      },
      {
        title: "成本率",
        dataIndex: "rate",
        width: 200,
        align: "center",
        slots: { customRender: "rate" },
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "operation",
        width: 200,

        slots: { customRender: "operation" },
      },
    ];

    const upload_headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };

    let loading = ref(false);

    const stateList = [
      {
        name: "未开始",
        val: 10,
      },
      {
        name: "签约中",
        val: 20,
      },
      {
        name: "合作中",
        val: 30,
      },
      {
        name: "已终结",
        val: 40,
      },
    ];

    let submitForm = ref({
      companyName: "",
      domain: "",
      business: [],
    });
    let imageUrl = "";
    const rules = {
      companyName: [
        { required: true, message: "请输入企业名称", trigger: "blur" },
      ],
    };
    const labelCol = { span: 2 };
    const wrapperCol = { span: 22 };
    let look = ref(false);
    let edit = ref(false);

    //methods
    const getDetail = () => {
      shopApi.getSupplier(route.query.id).then((res) => {
        submitForm.value = {
          companyName: res.name,
          domain: res.region,
          business: res.businessModules.split(","),
        };
        for (var i in res.supplierSettlements) {
          res.supplierSettlements[i].forEach((ele, index) => {
            delete ele.adminId;
            delete ele.createTime;
            delete ele.updateTime;
            delete ele.id;
            delete ele.distributorId;
            ele.lid = ele.businessModules + "_" + index;
            if (ele.endRange == 99999999) {
              ele.endRange = "";
            }
          });
          if (!res.supplierSettlements[i].length) {
            delete res.supplierSettlements[i];
          }
        }
        //避开watch的异步
        nextTick(() => {
          settlements.value = res.supplierSettlements;
          console.log(res.supplierSettlements);
        });
      });
    };

    //creat 逻辑
    const type = route.query.type;
    console.log(type);
    if (type === "look") look.value = true;
    if (type === "edit") edit.value = true;
    if (type) getDetail();

    const validation = () => {
      let tag = true;
      if (!submitForm.value.business.length) {
        message.error("请选择具体业务");
        return false;
      }
      //结尾是否是无尽 开头是否是小于等于1  是否是首尾相连
      Object.keys(settlements.value).forEach((element) => {
        console.log(settlements.value);
        let num = 0; //记录上一个结尾
        try {
          settlements.value[element].forEach((data, index) => {
            // 开头是否是小于等于1

            if (data.beginRange - 1 != num) {
              message.error("业务规则开头必须是1结尾是空的闭环");
              throw new Error("EndIterative");
              return;
            }
            //结尾必须是空
            if (
              index == settlements.value[element].length - 1 &&
              data.endRange !== ""
            ) {
              message.error("业务规则结尾必须是空");
              throw new Error("EndIterative");
              return;
            }
            if (!data.rateInfo && !data.priceIncrease) {
              message.error("请仔细填写加价费和加价率");
              throw new Error("EndIterative");
              return;
            }
            num = data.endRange;
          });
        } catch (e) {
          tag = false;
        }
      });

      return tag;
    };

    const delList = (key, index, row) => {
      settlements.value[key].splice(index, 1);
    };
    const addList = (key, row) => {
      settlements.value[key].push({
        businessModules: row.businessModules,
        beginRange: "",
        endRange: "",
        rateInfo: "",
        priceIncrease: "",
        lid: row.lid + "_" + row.businessModules,
      });
    };

    const submitFormAction = (form) => {
      itemrefs[0]
        .validate()
        .then(() => {
          console.log(1);
          //验证规则是否合法
          let rules = validation();
          console.log(rules);
          if (!rules) return;
          //整理参数
          let params = {
            name: submitForm.value.companyName,
            region: submitForm.value.domain,
            settlements: settlements.value,
          };
          loading.value = true;

          if (edit.value) {
            params.lid = route.query.id;
            shopApi.editSupplier(params).then((r) => {
              router.push({
                name: "shopIndex",
              });
              loading.value = false;
            });
          } else {
            shopApi
              .addSupplier(params)
              .then((r) => {
                router.push({
                  name: "shopIndex",
                });
                loading.value = false;
              })
              .catch((e) => {
                loading.value = false;
              });
          }
        })
        .catch((err) => {});
    };

    let oldFrom = 0;

    watch(submitForm.value, (val, pre) => {
      if (oldFrom != val.business.length) {
        let obj = {};
        val.business.forEach((element, index) => {
          if (settlements.value[settlementsKeys[element]]) {
            obj[settlementsKeys[element]] =
              settlements.value[settlementsKeys[element]];
          } else {
            obj[settlementsKeys[element]] = [
              {
                businessModules: element,
                beginRange: "",
                endRange: "",
                rateInfo: "",
                priceIncrease: "",
                lid: element + "_" + index,
              },
            ];
          }
        });
        settlements.value = obj;
        console.log(settlements);
      }
      oldFrom = val.business.length;
    });

    return {
      torefs,
      staticof,
      settlements,
      settlementsKeys,
      settlementsValue,
      columns,
      VUE_APP_URL,
      upload_headers,
      loading,
      stateList,
      submitForm,
      rules,
      labelCol,
      wrapperCol,
      look,
      edit,
      delList,
      addList,
      submitFormAction,
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.upload_images {
  width: 100px;
}
.bussiness_title {
  line-height: 20px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
</style>


